export default function flagMessageForPCINoncompliance(messageToTest) {
  const reg = new RegExp(
    /\b[2,3,4,5,6]\d{3}(|h|\s)?-?\d{4}(|h|\s)?-?\d{4}(|h|\s)?-?\d{4}\b|\b3(4|7)\d{2}(|h|\s)?-?\d{6}(|h|\s)?-?\d{5}\b/gm,
  );

  return reg.test(messageToTest);
}
